<template>
  <div>
    <b-navbar type="dark" id="main-line">
      <b-navbar-brand href="#" id="kopernik" class="d-flex"
        >АБЕЛЬ
        <div v-if="imageLogoExists" :key="'logo-div-' + componentImageKey" class="vl"></div>
        <b-img
          v-if="imageLogoExists"
          :src="imageLogo"
          :key="'logo-img-' + componentImageKey"
          alt=""
          style="width: 70px; height: 31px"
        />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav @click="getCurrentActiveLink()">
          <b-nav-item
            :to="{ name: 'positions' }"
            id="advertisers"
            class="ml-2"
            @click="fetchSovReports()"
            >Реклама
          </b-nav-item>
          <!-- <b-nav-item
            :to="{ name: 'keywords' }"
            id="keywords"
            class="ml-2"
            @click="fetchKeywordsStats()"
            >Ключевые слова
          </b-nav-item> -->
          <b-nav-item
            :to="{ name: 'usp' }"
            id="usp"
            class="ml-2"
            @click="fetchUspListSelected()"
            >УТП</b-nav-item
          >
          <b-nav-item
            :to="{ name: 'organic' }"
            id="organic"
            class="ml-2"
            @click="fetchOrganicSovReports()"
            >Органика
          </b-nav-item>
          <b-nav-item
            :to="{ name: 'ws' }"
            id="ws"
            class="ml-2"
            @click="fetchWordstat()"
            >Wordstat</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item v-if="isSuperuser" @click="createManagerTask" class="ml-2">Создать задачу</b-nav-item>
          <multiselect
            class="clients"
            v-model="currentProjectModel"
            :options="projects"
            :multiple="false"
            :close-on-select="true"
            :preserve-search="false"
            deselect-label="✓"
            select-label=""
            selectedLabel="✓"
            placeholder="Выберите проект"
            label="title"
            :searchable="false"
            track-by="id"
            :allowEmpty="false"
            v-if="projects.length > 0"
          >
          </multiselect>
          <b-nav-item @click="logout">Выйти</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import {mapActions, mapGetters} from "vuex";
import ChartAPI from "./chart-api";

export default {
  components: { Multiselect },
  data: () => ({
    componentImageKey: false,
    imageLogo: "",
    imageLogoExists: false,
  }),
  computed: {
    ...mapGetters(["projects", "currentProject"]),
    ...mapGetters('user', ['isSuperuser']),
    currentProjectModel: {
      get() {
        return this.currentProject;
      },
      async set(value) {
        localStorage.setItem("currentProject", JSON.stringify(value));
        sessionStorage.setItem("currentProject", JSON.stringify(value));
        let studObj = new ChartAPI();
        let jsonOurResponseAdvertiser = await studObj.getCompetitors(
          value["id"]
        );
        if (jsonOurResponseAdvertiser.length) {
          localStorage.setItem(
            "firstProjectAdvertiser",
            JSON.stringify(jsonOurResponseAdvertiser[0])
          );
          sessionStorage.setItem(
            "firstProjectAdvertiser",
            JSON.stringify(jsonOurResponseAdvertiser[0])
          );
        }
        this.selectCurrentProject({ currentProject: value, resetFilters: true });
        this.loadNavbarLogo();
      },
    },

    async mounted() {
      // @input="selectCurrentProject"
      // let projectStorage = localStorage.getItem('currentProject');
      // projectStorage ? await this.selectCurrentProject(JSON.parse(projectStorage)) : '';
      let activeLinkStorage =
        JSON.parse(localStorage.getItem("activeLink")) ||
        JSON.parse(sessionlStorage.getItem("activeLink"));
      activeLinkStorage
        ? document.getElementById(activeLinkStorage).firstElementChild.click()
        : "";
      await this.loadNavbarLogo();
    },
  },

  methods: {
    ...mapActions("sov_dashboard", ["fetchSovReports"]),
    ...mapActions("organic_sov_dashboard", ["fetchOrganicSovReports"]),
    ...mapActions("keywords", ["fetchKeywordsStats"]),
    ...mapActions("usp", ["fetchUspListSelected"]),
    ...mapActions("wordstat", ["fetchWordstat"]),
    ...mapActions(["selectCurrentProject", "loadProjectLogo", "clearUserState"]),
    ...mapActions("filters", ["selectAdvertisersFilter"]),

    getCurrentActiveLink() {
      localStorage.setItem(
        "activeLink",
        JSON.stringify(
          document.getElementsByClassName("router-link-exact-active")[0]
            .parentElement.id
        )
      );
      sessionStorage.setItem(
        "activeLink",
        JSON.stringify(
          document.getElementsByClassName("router-link-exact-active")[0]
            .parentElement.id
        )
      );
    },

    async loadNavbarLogo() {
      this.imageLogoExists = false;
      this.imageLogo = "";
      let jsonResponse = await this.loadProjectLogo(this.currentProject);
      if (typeof jsonResponse !== "undefined" && jsonResponse["logo_url"]) {
        this.imageLogo = jsonResponse["logo_url"];
        this.imageLogoExists = true;
      } else {
        this.imageLogoExists = false;
      }
      this.componentImageKey = !this.componentImageKey;
    },

    async createManagerTask() {
      try {
        const response = await fetch('/api/v1/create-manager-task/', {
          method: 'GET',
          credentials: 'include',
        });
        if (!response.ok) {
          throw new Error('Ошибка при формировании файла');
        }
        const blob = await response.blob();
        let filename = 'task.csv';
        const disposition = response.headers.get('Content-Disposition');
        if (disposition && disposition.indexOf('filename=') !== -1) {
          const matches = disposition.match(/filename="?([^";]+)"?/);
          if (matches && matches[1]) {
            filename = matches[1];
          }
        }
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        throw e;
      }
    },
    
    logout() {
      // Очищаем состояние приложения
      this.clearUserState();
      // Очищаем localStorage
      localStorage.clear();
      sessionStorage.clear();
      // Принудительно перенаправляем на страницу логина
      window.location.href = '/login/?next=/';
    },
  },
};
</script>

<style></style>
